import image1 from "../../../assets/images/negocio/negocio-1.png"
import image2 from "../../../assets/images/negocio/negocio-2.png"

export const negocioData = {
    items: [
        {
            image: image1,

            title: 'Cobra rápido con <strong>Toke pa’ tu negocio</strong>',

            text: `
        <p>
          Pónsela fácil a tus clientes, activa Toke y recibe pagos al instante por QR o número de celular, sin usar efectivo ni tener que enviar tus datos bancarios. 
        </p>
        <p>Cuando toca cobrar, Toke.</p>
      `,

            cta: {
                label: 'Descúbrelo aquí',
                url: '#'
            }
        },

        {
            image: image2,

            title: 'Asi funciona </br> <strong>Toke pa’ ti</strong>',

            text: `
        <ul>
          <li>Si eres cliente Popular o Qik, activa el botón de pagos desde tu app.</li>
          <li>¿No eres cliente? Descarga el App Toke y activa tu cuenta con tu cédula y número de teléfono.</li>
          <li>Envía y recibe pagos instantáneos y sin comisiones entre Popular, Qik y Toke usando código QR o número de celular.</li>
          <li>Recibe transferencias desde otros bancos a tu cuenta Toke.</li>
        </ul>
      `,

            cta: {
                label: 'Descúbrelo aquí',
                url: '#'
            }
        }
    ]
};
